import { render, staticRenderFns } from "./ModelsSection.vue?vue&type=template&id=cfef2df2&"
import script from "./ModelsSection.vue?vue&type=script&lang=js&"
export * from "./ModelsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports